import { motion } from 'framer-motion';
import { Shield, Zap, Clock, Smartphone, Lock, CheckCircle } from 'lucide-react';

const benefits = [
  {
    icon: Shield,
    title: 'Segurança Total',
    description: 'Suas encomendas ficam protegidas em compartimentos individuais com fechadura eletrônica.',
  },
  {
    icon: Zap,
    title: 'Praticidade',
    description: 'Retire suas encomendas sem filas, sem espera, sem complicações.',
  },
  {
    icon: Clock,
    title: 'Disponível 24/7',
    description: 'Acesse o locker a qualquer hora do dia ou da noite, 7 dias por semana.',
  },
  {
    icon: Smartphone,
    title: 'Experiência Digital',
    description: 'Tudo pelo celular: notificações, código de acesso e histórico de retiradas.',
  },
  {
    icon: Lock,
    title: 'Autonomia',
    description: 'Você no controle. Sem depender de porteiros, vizinhos ou horários comerciais.',
  },
  {
    icon: CheckCircle,
    title: 'Confiabilidade',
    description: 'Tecnologia comprovada com mais de 10.000 entregas realizadas com sucesso.',
  },
];

export const Benefits = () => {
  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23D4FF00' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="inline-block bg-lokker-lime text-black text-sm font-bold px-4 py-2 rounded-sm mb-4 uppercase tracking-wide">
            Benefícios
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-4">
            Por que escolher o Use Lokker?
          </h2>
          <p className="text-lg text-slate-400">
            Uma nova forma de receber suas encomendas, pensada para o seu dia a dia moderno.
          </p>
        </motion.div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`benefit-card-${index + 1}`}
              className="group relative bg-slate-800/50 backdrop-blur-sm border border-slate-700 p-8 rounded-sm hover:border-lokker-lime transition-all duration-300"
            >
              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-16 h-16 overflow-hidden">
                <div className="absolute -top-8 -right-8 w-16 h-16 bg-lokker-lime/10 rotate-45 group-hover:bg-lokker-lime/20 transition-colors" />
              </div>

              {/* Icon */}
              <div className="w-14 h-14 bg-lokker-blue rounded-sm flex items-center justify-center mb-6 group-hover:bg-lokker-lime transition-colors duration-300">
                <benefit.icon className="w-7 h-7 text-white group-hover:text-black transition-colors duration-300" />
              </div>

              {/* Content */}
              <h3 className="font-heading font-semibold text-xl text-white mb-3">
                {benefit.title}
              </h3>
              <p className="text-slate-400 leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Bottom Stats */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center"
        >
          <div className="p-6">
            <p className="font-heading font-bold text-4xl text-lokker-lime">10k+</p>
            <p className="text-slate-400 mt-2">Entregas</p>
          </div>
          <div className="p-6">
            <p className="font-heading font-bold text-4xl text-lokker-lime">500+</p>
            <p className="text-slate-400 mt-2">Lockers</p>
          </div>
          <div className="p-6">
            <p className="font-heading font-bold text-4xl text-lokker-lime">50+</p>
            <p className="text-slate-400 mt-2">Cidades</p>
          </div>
          <div className="p-6">
            <p className="font-heading font-bold text-4xl text-lokker-lime">99%</p>
            <p className="text-slate-400 mt-2">Satisfação</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;
